import { createIamSessionClient } from "@itaas/core/auth/iam-session.service";
import type { LoginCredentials } from "@itaas/core/auth/auth.types";
import type { AuthSession } from "@itaas/core/auth/models/session.model";
import { iamRequest } from "@/core/billing/api/iam-client";
import { IAM_TENANT_SLUG } from "@/core/billing/config";

const iam = createIamSessionClient({
  iamRequest,
  tenantSlug: IAM_TENANT_SLUG,
  defaultTenantName: "ITaaS Demo",
});

export const billingSessionApi = iam;

export function billingLogin(credentials: LoginCredentials): Promise<AuthSession> {
  return iam.login(credentials);
}

export function billingLogout(): Promise<void> {
  return iam.logout();
}

export function billingRefreshToken(refreshToken: string) {
  return iam.refreshToken(refreshToken);
}

export function billingVerifySession(): Promise<AuthSession | null> {
  return iam.verifySession();
}

export {
  changePassword,
  forgotPassword,
  resetPassword,
} from "@itaas/core/auth/auth.service";
